export function navigateTo(url: string): void {
    window.location.assign(url);
}
